/**
 * Global animation-speed control. Settings UI will read/write this later;
 * for now the speed is module-level state with `fast` as the default so the
 * current "1s BUST" timing is preserved.
 *
 * Convention: callers pass the FAST-speed duration to `scaleDuration`; the
 * helper multiplies by the active speed's multiplier.
 */
export type AnimationSpeed = 'fast' | 'regular' | 'slow';

const SPEED_MULTIPLIERS: Record<AnimationSpeed, number> = {
  fast: 1,
  regular: 1.5,
  slow: 2,
};

let currentSpeed: AnimationSpeed = 'fast';

export function setAnimationSpeed(speed: AnimationSpeed): void {
  currentSpeed = speed;
}

export function getAnimationSpeed(): AnimationSpeed {
  return currentSpeed;
}

/** Multiplies a fast-speed duration (ms) by the active speed's multiplier. */
export function scaleDuration(fastDurationMs: number): number {
  return Math.round(fastDurationMs * SPEED_MULTIPLIERS[currentSpeed]);
}
